import { Box, Checkbox, Chip, FormControl, IconButton, InputAdornment, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Switch, TextField } from "@mui/material"
import { Image as ImageIcon, VisibilityOff as VisibilityOffIcon, Visibility as VisibilityIcon, NoPhotography as NoPhotographyIcon } from "@mui/icons-material"
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { SketchPicker } from "react-color"
import { ColorPicker } from 'react-color-gradient-picker';
import { useState } from "react";
import { Editor } from "@monaco-editor/react";

export const TextInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  inputProps,
  endAdornment,
  startAdornment,
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction
}) => {
  const [values, setValues] = useState(false)

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    {type !== "password" ?
      <TextField
        fullWidth
        id={id}
        margin="dense"
        type={type}
        size={(size !== undefined && size !== null) ? size : "size"}
        name={id}
        InputProps={{
          inputProps: (inputProps !== undefined && inputProps !== null) ? inputProps : {},
          endAdornment: (endAdornment !== undefined && endAdornment !== null) ? <InputAdornment position="end">{endAdornment.value}</InputAdornment> : null,
          startAdornment: (startAdornment !== undefined && startAdornment !== null) ? <InputAdornment position="start">{startAdornment.value}</InputAdornment> : null
        }}
        value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
        {...register(id)}
        error={errors[id] ? true : false}
        onChange={changeDataFunction} />
      :
      <FormControl variant="standard" fullWidth>
        <OutlinedInput
          id={id}
          size="small"
          type={values ? 'text' : 'password'}
          name={id}
          value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
          {...register(id)}
          error={errors[id] ? true : false}
          onChange={changeDataFunction}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setValues(!values)}
                onMouseDown={(event) => { event.preventDefault() }}
                edge="end"
              >
                {values ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    }
  </>)
}

export const SelectInputC = ({
  id,
  name,
  type,
  required,
  containerOptions,
  defaultValue,
  size,
  instance,
  containerSelectOptions,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction
}) => {

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    <TextField
      fullWidth
      id={id}
      select
      margin="dense"
      size={(size !== undefined && size !== null) ? size : "size"}
      name={id}
      value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
      {...register(id)}
      error={errors[id] ? true : false}
      onChange={changeDataFunction}>
      {containerSelectOptions[containerOptions].map((opt, index) => (
        <MenuItem key={`${index}-${opt.value}`} value={opt.value}>{opt.label}</MenuItem>
      ))}
    </TextField>
  </>)
}

export const MultiSelectInputC = ({
  id,
  name,
  type,
  required,
  containerOptions,
  defaultValue,
  size,
  instance,
  containerSelectOptions,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction
}) => {

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    <FormControl fullWidth>
      <Select
        fullWidth
        margin="dense"
        size="small"
        labelId="demo-multiple-chip-label"
        id="demo-multiple-chip"
        multiple
        value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
        {...register(id)}
        error={errors[id] ? true : false}
        onChange={(e) => changeDataFunction(e, id)}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={
                containerSelectOptions[containerOptions].find((r) => { return r.value === value }).label
              } />
            ))}
          </Box>
        )}
      >
        {containerSelectOptions[containerOptions].map((bo) => (
          <MenuItem key={bo.value} value={bo.value}>
            <Checkbox checked={checkIfPropertyIsInInstance(id) ? instance[id].indexOf(bo.value) > -1 : false} />
            <ListItemText primary={bo.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </>)
}

export const SwitchC = ({
  id,
  name,
  required,
  instance,
  checkIfPropertyIsInInstance,
  register,
  changeDataFunction
}) => {

  if (id === undefined || id === null) {
    return <>Falta el atributo id</>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  }

  return (<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    <Switch edge="end" required={required} inputProps={{ 'aria-labelledby': `switch-list-label-${id}` }}
      onClick={() => changeDataFunction(id)}
      checked={checkIfPropertyIsInInstance(id) ? instance[id] : false}
      {...register(id)}
    />
  </>)
}

export const ImageInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction,
  setFieldImageManager,
  openImageManager
}) => {

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (
    <div style={{ display: "grid", gridTemplateColumns: "40% 60%" }}>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {instance[id] === undefined || !Array.isArray(instance[id]) ?
          <NoPhotographyIcon fontSize="large" /> : <>
            {/* <img 
          src={instance !== undefined ? instance[id] : ""} 
          style={{ width: "90%" }} 
          alt={`${instance[id]}-imagen`} /> */}
            <img src={URL.createObjectURL(instance[id][0].file)} /* alt={item.file.path} */ style={{ maxWidth: "100px", height: "fit-content" }} />
          </>
        }
      </div>
      <div>
        <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
        {/* <TextField
          fullWidth
          id={id}
          margin="dense"
          type="text"
          size={(size !== undefined && size !== null) ? size : "size"}
          name={id}
          value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
          {...register(id)}
          error={errors[id] ? true : false}
          onChange={changeDataFunction} /> */}
        <IconButton onClick={() => { setFieldImageManager(id); openImageManager(); }}><ImageIcon /></IconButton>
      </div>
    </div>
  )
}

/* export const ColorInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction,
  changeCompletePicker
}) => {

  if(id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if(name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if(type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if(defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return(<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    <TextField 
      fullWidth 
      id={id} 
      margin="dense" 
      type="text" 
      size={(size !== undefined && size !== null) ? size : "size"} 
      name={id}
      value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
      {...register(id)} 
      error={errors[id] ? true: false}
      onChange={changeDataFunction}
      sx={{
        input: {
          color: "#a3a3a3",
          backgroundColor: checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue,
        }
      }}
      />
      <SketchPicker presetColors={[]}
        color={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
        onChangeComplete={ (color) => changeCompletePicker(color, id) }
      />
  </>)
} */

export const ColorInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  tooltip = "",
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction,
  changeCompletePicker
}) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker)
  };

  const handleClose = () => {
    setDisplayColorPicker(false)
  };

  const handleChange = (color) => {
    changeCompletePicker(color, id)
  };

  return (<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    {/* <div>
      <div style={{ padding: '5px', background: '#fff', borderRadius: '1px', boxShadow: '0 0 0 1px rgba(0,0,0,.1)', display: 'inline-block', cursor: 'pointer' }} onClick={handleClick}>
        <div style={{ width: '36px', height: '14px', borderRadius: '2px', background: checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue }} />
      </div>
      {displayColorPicker ? <div style={{ position: 'relative', zIndex: '2', left: -150 }}>
        <div style={{ position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px', width: 32, height: 32, borderRadius: 50, background: "#9e9e9e", position: "absolute", zIndex: 3, left: 210, top: -20, display: "flex", justifyContent: "center", alignItems: "center", color: "#ffffff", fontWeight: "bold", cursor: "pointer" }} onClick={handleClose}>x</div>
        <SketchPicker color={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue} onChange={handleChange} style={{ position: "absolute" }}/>
      </div> : null}
    </div> */}
    <div>
      <TextField
        style={{ width: "65px" }}
        id={id}
        margin="dense"
        type="color"
        size={size}
        name={id}
        value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
        {...register(id)}
        error={errors[id] ? true : false}
        onChange={changeDataFunction} />
    </div>
  </>)
}

export const ColorGradientInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  size = 3,
  instance,
  checkIfPropertyIsInInstance,
  changeColorGradient
}) => {
  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <ColorPicker onStartChange={changeColorGradient} onChange={changeColorGradient} onEndChange={changeColorGradient} gradient={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue} isGradient
      />
    </div>
  </>)
}

export const DateTimePickerInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction
}) => {

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es-mx">
      <DateTimePicker disablePast={true}
        renderInput={(props) => <TextField {...props} required={required} fullWidth size={size} margin="dense" />}
        value={checkIfPropertyIsInInstance(id) ? dayjs(instance[id]) : dayjs(defaultValue)}
        onChange={(newValue) => {
          changeDataFunction(id, newValue)
        }}
      />
    </LocalizationProvider>
  </>)
}

export const CodeEditorC = ({
  id,
  name,
  defaultValue,
  instance,
  checkIfPropertyIsInInstance,
  changeDataFunction
}) => {

  return (
    <>
      <InputLabel htmlFor={id} style={{ fontSize: 14 }}>{name}</InputLabel>
      <Editor
        height="50vh"
        defaultLanguage="html"
        //defaultValue="<!-- Write your code here -->"
        onChange={(value, event) => { changeDataFunction(id, value) }}
        value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
        theme="vs-dark" />
    </>
  )
}
